/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createString } from '../../factoriesAny.js';
export var stringDependencies = {
  typedDependencies: typedDependencies,
  createString: createString
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesString.generated.js
// module id = 1664
// module chunks = 0